function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9 3.4621V1.9121C14.9 1.4871 14.725 1.1121 14.4 0.862103C14.075 0.612103 13.65 0.512103 13.25 0.587103L1.95005 3.3121H1.75005C0.950049 3.3121 0.300049 3.9621 0.300049 4.7621V11.9871C0.300049 12.7871 0.950049 13.4371 1.75005 13.4371H14.25C15.05 13.4371 15.7 12.7871 15.7 11.9871V4.7371C15.7 4.1871 15.375 3.7121 14.9 3.4621ZM13.425 1.4621C13.575 1.4371 13.725 1.4621 13.825 1.5621C13.95 1.6621 14 1.7871 14 1.9371V3.3121H5.70005L13.425 1.4621ZM1.75005 4.1871H14.25C14.55 4.1871 14.825 4.4371 14.825 4.7621V5.9621H1.20005V4.7371C1.20005 4.4371 1.45005 4.1871 1.75005 4.1871ZM14.825 6.8121V8.2621H1.20005V6.8121H14.825ZM14.25 12.5371H1.75005C1.45005 12.5371 1.17505 12.2871 1.17505 11.9621V9.1371H14.8V11.9621C14.825 12.2871 14.55 12.5371 14.25 12.5371Z",
  fill: "#334156"
});
function SvgIconCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCard);
export default __webpack_public_path__ + "static/media/icon-card.fe0c0059302f7a3f89905f826bb80204.svg";
export { ForwardRef as ReactComponent };